import React, { useEffect, useState } from "react";
import api from "../../api";
import "bootstrap/dist/css/bootstrap.min.css";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../../utils/toastMessages";
import { formatDateToUserTimeZone } from "../../utils/formatDate";
import axios from "axios";
import viewIcon from "../../assets/UserIcons/ViewIcon.svg";
import crossIcon from "../../assets/UserIcons/Cancel.svg";
import { useTableSort } from "../../hooks/useTableSort";
import { SortableHeader } from "../../components/SortableHeader";

const TrainingText = ({}) => {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [uploadedText, setUploadedText] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const [showViewTextModal, setShowViewTextModal] = useState(false);
  const [viewTextContent, setViewTextContent] = useState("");
  const [summary, setSummary] = useState({
    totalChars: 0,
    totalWords: 0,
    usedPercent: 0,
    isOverLimit: false,
    overByChars: 0,
    approvedCount: 0,
    rejectedCount: 0,
    totalTexts: 0,
  });

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const countWords = (text = "") =>
    text.trim() ? text.trim().split(/\s+/).length : 0;

  // ---- Limits (config / env / API later)
  const LIMIT = 100000; // example – 0 breaks percentage logic

  useEffect(() => {
    // if (!uploadedText.length) return;
    if (!uploadedText.length) {
      setSummary({
        totalChars: 0,
        totalWords: 0,
        usedPercent: 0,
        isOverLimit: false,
        overByChars: 0,
        approvedCount: 0,
        rejectedCount: 0,
        totalTexts: 0,
      });
      return;
    }

    let approvedChars = 0;
    let approvedWords = 0;
    let approvedCount = 0;
    let rejectedCount = 0;

    uploadedText.forEach((item) => {
      if (String(item.upload_status) === "1") {
        approvedCount++;
        approvedChars += item.text_content?.length || 0;
        approvedWords += countWords(item.text_content || "");
      } else {
        rejectedCount++;
      }
    });

    const isOverLimit = approvedChars > LIMIT;
    const overByChars = isOverLimit ? approvedChars - LIMIT : 0;
    const usedPercent =
      LIMIT > 0 ? Math.min(Math.round((approvedChars / LIMIT) * 100), 100) : 0;

    setSummary({
      totalChars: approvedChars,
      totalWords: approvedWords,
      usedPercent,
      isOverLimit,
      overByChars,
      approvedCount,
      rejectedCount,
      totalTexts: uploadedText.length,
    });
  }, [uploadedText, LIMIT]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ❌ Frontend validation
    if (!text.trim()) {
      showErrorToast(TOAST_MESSAGES.TEXT_UPLOAD.EMPTY);
      return;
    }

    // if (isOverLimit) {
    //   showErrorToast(
    //     `Character limit exceeded by ${overByChars.toLocaleString()} characters`,
    //   );
    // }

    //     if (isOverLimit) {
    //   showErrorToast("Upload limit reached");
    //   return;
    // }

    setIsAdding(true);
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/upload/text`,
        {
          text,
          title: "User Input Text",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // ✅ SUCCESS (201)
      if (response.status === 201) {
        showSuccessToast(TOAST_MESSAGES.TEXT_UPLOAD.SUCCESS);
        setText("");
        fetchTexts();
      }
    } catch (err) {
      const status = err.response?.status;
      const message = err.response?.data?.message;

      // ⚠️ DUPLICATE
      if (status === 409) {
        showErrorToast(message || TOAST_MESSAGES.TEXT_UPLOAD.DUPLICATE);
      }
      // ❌ VALIDATION
      else if (status === 400) {
        showErrorToast(message || TOAST_MESSAGES.TEXT_UPLOAD.EMPTY);
      }
      // 🚧 FASTAPI FAILURE
      else if (status === 502) {
        showErrorToast(message || TOAST_MESSAGES.TEXT_UPLOAD.PROCESSING_FAILED);
      }
      // ❌ GENERIC ERROR
      else {
        showErrorToast(TOAST_MESSAGES.TEXT_UPLOAD.ERROR);
      }

      console.error("Upload error:", err.response?.data || err.message);
    } finally {
      setLoading(false);
      setIsAdding(false);
    }
  };

  useEffect(() => {
    fetchTexts();
  }, []);

  const fetchTexts = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/uploaded-files/text`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setUploadedText(res.data);
    } catch (err) {
      console.error("❌ Failed to fetch uploaded texts:", err);
      showErrorToast("Error loading uploaded text");
    }
  };

  const handleChangeQAStatus = async (uploadId, currentStatus) => {
    console.log(currentStatus);
    const newStatus = currentStatus == "1" ? "0" : "1";

    console.log(uploadId);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/uploaded-files/update_qa_status/${uploadId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ upload_status: newStatus }),
        },
      );

      const result = await response.json();

      if (!response.ok) {
        showErrorToast(result.message || "Failed to update status");
        return;
      }

      showSuccessToast("Status updated successfully");

      // Refresh your QA list
      fetchTexts();
    } catch (err) {
      console.error("Error updating status:", err);
      showErrorToast("Something went wrong");
    }
  };

  const handleViewText = (item) => {
    setViewTextContent(item.text_content || "");
    setShowViewTextModal(true);
  };

  const summaryBars = summary.isOverLimit
    ? [
        ,
        { label: "Used Capacity", value: summary.usedPercent },
        {
          label: "Remaining Capacity",
          value: Math.max(100 - summary.usedPercent, 0),
        },
        // { label: "Limit Exceeded", value: 100 },
      ]
    : [
        { label: "Used Capacity", value: summary.usedPercent },
        {
          label: "Remaining Capacity",
          value: Math.max(100 - summary.usedPercent, 0),
        },
      ];

  const { sortedData, requestSort, sortConfig } = useTableSort(uploadedText);
  return (
    <div
      className="m-0 px-2 h-100"
    >
      <div className="row">
        {/* Upload Form */}
        <div className="col-lg-8">
          <div className="card profile shadow-sm rounded-lg p-4">
            <h5 className="fw-bold mb-3 ak-text-lg">Text</h5>

            <form onSubmit={handleSubmit}>
              <div className="mb-4" style={{ height: "240px" }}>
                <textarea
                  className="input-textarea1 h-100 border-1"
                  placeholder="Enter text..."
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  style={{
                    border: "dashed var(--input-border-color)",
                  }}
                  disabled={isAdding} // ✅ disabled while adding
                />
                <div className="d-flex justify-content-end small refresh-prompts mt-1">
                  {countWords(text)} words · {text.length} characters
                </div>
              </div>

              <div className="d-flex gap-3">
                <button
                  type="submit"
                  className="custom-btn flex-fill  w-semibold"
                  disabled={isAdding}
                >
                  {isAdding ? "Uploading..." : "Upload"}
                </button>
              </div>
            </form>
          </div>

          {/* Uploaded Text Table */}
          <div className="mt-4">
            <div
              className="table-responsive"
              style={{ maxHeight: "420px", overflowY: "auto" }}
            >
              <table className="table text-center trainingUrls-table align-middle">
                <thead className="text-left">
                  <tr>
                    <SortableHeader
                      column="text_content"
                      label="Text"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    />
                    <SortableHeader
                      column="text_length"
                      label="Total Characters"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    />
                    <SortableHeader
                      column="created_timestamp"
                      label="Uploaded On"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    />
                    {/* <SortableHeader
                      column="upload_status"
                      label="Status"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    /> */}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="text-left">
                  {sortedData.length > 0 ? (
                    sortedData.map((item, index) => (
                      <tr key={index}>
                        <td
                          className="text-truncate"
                          style={{ maxWidth: "170px" }}
                          title={item.text_content}
                        >
                          {item.text_content}
                        </td>

                        <td>{item.text_content?.length || 0}</td>
                        <td>
                          {formatDateToUserTimeZone(
                            new Date(item.created_timestamp),
                          )}
                        </td>
                        {/* <td className="text-left">
                          <select
                            className={`badge ${
                              item.upload_status == "1"
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                            value={String(item.upload_status)} // ensure string
                            onChange={(e) =>
                              handleChangeQAStatus(
                                item.upload_id,
                                item.upload_status,
                              )
                            }
                          >
                            <option value="1">Approved</option>
                            <option value="0">Rejected</option>
                          </select>
                        </td> */}
                        <td>
                          <img
                            src={viewIcon} // 👁️ image icon
                            alt="View"
                            title="View Text"
                            className="icon-image"
                            style={{ cursor: "pointer", width: "18px" }}
                            onClick={() => handleViewText(item)}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      {/* {VKD125 completed make it left side} */}
                      <td colSpan="6" className="refresh-prompts ak-text-md">
                        No text uploaded yet. Start uploading text to see usage
                        summary.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {showViewTextModal && (
          <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
            <div className="modal-history modal-dialog-centered history-model">
              <div className="modal-content w-100 position-relative">
                {/* ❌ CLOSE BUTTON */}
                <button
                  type="button"
                  className="modal-close-btn position-absolute top-0 end-0 mt-2 me-2"
                  onClick={() => {
                    setShowViewTextModal(false);
                    setViewTextContent("");
                  }}
                >
                  <img
                    src={crossIcon}
                    className="icon-image cross-i"
                    alt="Close"
                  />
                </button>

                <p className="fw-bold mt-3 mb-3 text-center refresh-prompts">
                  Uploaded Text Content
                </p>

                {/* 📄 CONTENT */}
                <div className="text-center p-3">
                  <div
                    className="px-2"
                    style={{
                      maxHeight: "200px",
                      overflowY: "auto",
                      textAlign: "left",
                      whiteSpace: "pre-wrap",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      padding: "10px",
                      backgroundColor: "var(--repo-card-bg)",
                      fontSize: "14px",
                      lineHeight: "1.5",
                    }}
                  >
                    {viewTextContent}
                  </div>
                </div>

                {/* FOOTER */}
                <div className="modal-footer justify-content-center">
                  <button
                    type="button"
                    className="px-5 rounded custom-btn border-none py-2 fw-bold history-btn"
                    onClick={() => {
                      setShowViewTextModal(false);
                      setViewTextContent("");
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Right Summary (Dynamic) */}
        <div className="col-lg-4">
          <div className="card profile p-4 shadow-sm">
            <h5 className="fw-semibold mb-4 ak-text-md">Summary</h5>
            <div className="d-flex justify-content-center align-items-center mb-4 position-relative">
              <svg
                width="140"
                height="140"
                viewBox="0 0 36 36"
                className="circular-chart"
              >
                <path
                  className="circle-bg"
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="#eee"
                  strokeWidth="2"
                />
                <path
                  className="circle"
                  strokeDasharray={`${summary.usedPercent}, 100`}
                  stroke={summary.isOverLimit ? "#dc3545" : "#3e3e3e"}
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  // stroke="#3e3e3e"
                  strokeWidth="2"
                />
              </svg>
              {/* Center text wrapper */}
              <div className="position-absolute text-center">
                <div className="ak-text-md">
                  {summary.isOverLimit ? "Limit Exceeded" : "Used"}
                </div>
                <div className="fw-bold fs-2">{summary.usedPercent}%</div>
              </div>
            </div>

            <div className="row text-center mb-4">
              <div className="col">
                <div className="ak-text-md fw-semibold">Total Text</div>
                <div className="fw-semibold">{summary.totalTexts}</div>
              </div>

              <div className="col">
                <div className="ak-text-md fw-semibold text-success">
                  Approved
                </div>
                <div className="fw-semibold">{summary.approvedCount}</div>
              </div>

              <div className="col">
                <div className="ak-text-md fw-semibold text-danger">
                  Rejected
                </div>
                <div className="fw-semibold">{summary.rejectedCount}</div>
              </div>
            </div>
            <div className="row text-center mb-4">
              <div className="col">
                <div className="ak-text-md fw-semibold">Words</div>
                <div className="fw-semibold">
                  {summary.totalWords.toLocaleString()}
                </div>
              </div>
              <div className="col">
                <div className="ak-text-md fw-semibold">Characters</div>
                <div className="fw-semibold">
                  {summary.totalChars.toLocaleString()}
                </div>
              </div>
              <div className="col">
                <div className="ak-text-md fw-semibold">Limit</div>
                <div className="fw-semibold">{LIMIT.toLocaleString()}</div>
              </div>
            </div>

            {summaryBars.map((item, idx) => (
              <div key={idx} className="mb-3">
                <div className="d-flex justify-content-between small fw-semibold">
                  <span className="text-secondary">{item.label}</span>
                  <span>{item.value}%</span>
                </div>

                <div className="progress-track">
                  <div
                    className="progress-fill"
                    role="progressbar"
                    style={{ width: `${item.value}%` }}
                  />
                </div>
              </div>
            ))}

            {/* Warning when close to limit */}
            {!summary.isOverLimit && summary.usedPercent >= 80 && (
              <div className="text-center small mb-2">
                Almost there! You’re close to the training limit.
              </div>
            )}

            {/* Exact limit reached */}
            {summary.usedPercent === 100 && !summary.isOverLimit && (
              <div className="text-success text-center small mb-2">
                Training data limit reached 🎉
              </div>
            )}

            {summary.isOverLimit && (
              <div className="alert alert-warning py-2 mb-3 text-center">
                ⚠️ Character limit exceeded by{" "}
                <strong>{summary.overByChars.toLocaleString()}</strong>{" "}
                characters.
                <div className="small mt-1">
                  New uploads are allowed but won’t improve training quality.
                </div>
              </div>
            )}

            {/* {rejectedCount > 0 && (
              <div className="text-center small text-danger mb-3">
                {rejectedChars.toLocaleString()} characters are currently
                rejected
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingText;
